module.exports = "<div \n\t:style=\"{'background-color': siteData.website_color, 'min-height': '100vh'}\"\n\tv-if=\"siteData\">\n\t<qd-search\n\t\t:color=\"siteData.website_color\"\n\t\t:transition=\"transition\"\n\t\t@updatetransition=\"updateTransition\">\n\t\t<router-view \n\t\t\t:site-data=\"siteData\" \n\t\t\t:app-loaded=\"appLoaded\" \n\t\t\t:transition=\"transition\"\n\t\t\t@updatetransition=\"updateTransition\"\n\t\t\t@updatelangs=\"updateLangs\"/>\n\t</qd-search>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/app.vhtml
// module id = 269
// module chunks = 0